import React from 'react'
import { NavLink } from 'react-router-dom'
import './NavigationMenu.css'

export default function NavigationMenu() {
  return (
    <>
       <div className='nav-link-container'>
            <NavLink to="/" className='nav-link'>Home</NavLink>
            <NavLink to="/top_collections" className='nav-link'>Watches</NavLink>
            <NavLink to="/our_collection" className='nav-link'>Earbuds</NavLink>
            <NavLink to="/electronics" className='nav-link'>Wallets</NavLink>
            <NavLink to="/home_improvement" className='nav-link'>Cosmetics</NavLink>
            <NavLink to="/about-us" className='nav-link'>About us</NavLink>
            <NavLink to="/contact-us" className='nav-link'>Contact us</NavLink>
        </div>
    </>
  )
}